// noinspection JSUnusedGlobalSymbols imported via d.ts file
import {createModalV2} from "../../../../../helpers/modals/modalV2";
import {clearFeedbacksByName, fillInputsByName} from "../../../../../helpers/forms";
import {setAsDateField} from "../../../../../helpers/inputs";
import {syncInputValue} from "../../../../../helpers/inputs/syncInputs/syncInputValue";
import {displayLocalValidationError} from "../../../../../helpers/forms/validationErrors/utils";

// noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols -- imported via d.ts
/**
 * @param {GanttWrapper.GanttWrapper} gantt
 * @return {TaskDelaysModal.TaskDelaysModal}
 */
function createTaskDelaysModal(gantt) {
	/** @type {GanttWrapper.Delay[]} */
	let delays;

	// noinspection JSValidateTypes
	/**
	 * @type {TaskDelaysModal.TaskDelaysModal}
	 */
	const modal = createModalV2({
		// There should be only one instance of this modal on the DOM
		modalContainer: document.querySelector('.timeline-task-delays-modal'),
		init() {
			// Setup confirm button
			this.modalContainer.querySelector('.timeline-task-delays-modal-confirm-button')
				.addEventListener('click', () => {
					handleSuccess();
				})

			// Setup add delays buttons
			this.modalContainer.querySelector('.add-delay-button')
				.addEventListener('click', () => {
					addDelay();
				})

		}
	});

	// Override display function to setup on display
	// noinspection JSUndefinedPropertyAssignment
	modal._og_display = modal.display;

	modal.display = (task, firstTime = true) => {
		// Save task
		modal.currentTask = task;

		// Copy delays from task so we operate on a local copy
		delays = modal.currentTask.delays.map(delay => {
			// noinspection UnnecessaryLocalVariableJS -- We want type validation
			/**
			 * @type {GanttWrapper.Delay}
			 */
			const clonedDelay = {
				startDate: delay.startDate ? delay.startDate.clone() : undefined,
				type: delay.type,
				duration: delay.duration,
				reason: delay.reason,
				description: delay.description ? delay.description : '',
				admin_notes: delay.admin_notes ? delay.admin_notes : '',
			}

			return clonedDelay;
		});

		renderModal();

		// noinspection JSUnresolvedReference
		modal._og_display(firstTime);
	}

	// Get templates
	/**
	 * @type {HTMLElement}
	 */
	const delayContainerTemplate = modal.modalContainer.querySelector('.templates .delay-container');

	// noinspection JSValidateTypes
	return modal;

	// Methods
	function addDelay() {
		delays.push({
			reason: `Delay #${delays.length + 1}`,
			duration: 1,
			startDate: undefined,
			type: 'duration',
			description: '',
			admin_notes: '',
		})

		renderModal();
	}

	function renderModal() {
		// Update modal name
		modal.modalContainer.querySelector('.modal-title').innerText =
			`'${modal.currentTask.name}' Delays`;

		const delaysWrapper = modal.modalContainer.querySelector('.delays-container-wrapper');
		const delaysContainer = delaysWrapper.querySelector('.delays-container');
		const emptyMessage = delaysWrapper.querySelector('.empty-message');

		// Clear DOM
		delaysContainer.innerHTML = '';

		// Display or hide empty list message
		if (delays.length === 0) {
			emptyMessage.classList.remove('d-none');
		} else {
			emptyMessage.classList.add('d-none');
		}

		// Render delays
		delays.forEach((delay, index) => {
			const delayContainer = delayContainerTemplate.cloneNode(true);

			delayContainer.dataset.delayIndex = index.toString();

			// Fill inputs
			fillInputsByName(delayContainer, delay)

			// Initialize date pickers
			const startDateField = delayContainer.querySelector('input[name="start"]');

			setAsDateField(startDateField, {
				date: delay.startDate,
				widgetPositioning: {
					horizontal: 'right',
				},
				wrapperSettings: {
					showClearButton: true,
				}
			});

			// Setup delete button
			delayContainer.querySelector('.delete-delay-button')
				.addEventListener('click', () => {
					const index = delays.indexOf(delay);

					// Remove exception from local array
					delays.splice(index, 1);

					// Refresh list
					renderModal();
				})

			// Sync inputs
			const inputsToSync = [
				'reason',
				'duration',
				'description',
				'admin_notes',
			];

			inputsToSync.forEach(inputField => {
				const inputElement =
					delayContainer.querySelector(`input[name="${inputField}"],textarea[name="${inputField}"]`);

				if (inputElement) {
					syncInputValue(
						delay,
						inputElement,
						inputField
					);
				}
			})

			$(startDateField).on('dp.change', () => {
				delay.startDate = $(startDateField).data("DateTimePicker").date();
			})

			delaysContainer.appendChild(delayContainer);
		})
	}

	function handleSuccess() {
		// Make sure we should be able to save this
		if (validateSettings() === false) {
			return;
		}

		// Make sure durations are treated as numbers
		delays.forEach(delay => {
			// noinspection JSCheckFunctionSignatures
			delay.duration = parseInt(delay.duration);
		})

		// Update tasks delays with local copy
		modal.currentTask.delays = delays;

		modal.hide();

		// Notify gantt to refresh view
		modal.notifySuccessListeners();
	}

	function validateSettings() {
		clearFeedbacksByName(modal.modalContainer);

		for (const delay of delays) {
			const index = delays.indexOf(delay);
			const exceptionContainer = modal.modalContainer
				.querySelector(`.delay-container[data-delay-index="${index}"]`);
			if (delay.reason.trim() === '') {
				displayLocalValidationError(exceptionContainer, 'reason', 'Reason field required');

				// Reject empty exception
				return false;
			}
			if (delay.reason.length > 800) {
				displayLocalValidationError(exceptionContainer, 'reason', 'Delay reason must be less than 800 chars');

				return false;
			}

			if (isNaN(delay.duration) || delay.duration < 1) {
				displayLocalValidationError(exceptionContainer, 'duration', 'Delay duration must be at least 1');

				return false;
			}
		}

		return true;
	}
}

export {createTaskDelaysModal}
